
import { blue,blueGrey } from "@mui/material/colors";
import IconButton, { collapseClasses, Divider } from "@mui/material";
import {styled, Button} from "@mui/material";
import {defaultThemes } from "react-data-table-component";
import { RoundedCorner } from "@mui/icons-material";
import QRCode from "react-qr-code";
import {Stack } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import Typography from '@mui/material/Typography';
import { Fragment } from "react";
import {Grid2,Avatar} from '@mui/material';
import { light } from "@mui/material/styles/createPalette";
import { ENEA_GEST_API_URL, ENEA_GEST_BASE_URL } from "./Statics";

const concurrecySort = (a,b)=>{
    return a-b;
}

const dateSort = (a,b)=>{
    
    return new Date(a)-new Date(b);
}

// color style reviewed in date 28 apr 2025

const EneaButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(blueGrey[500]),
    borderRadius:0,
    fontFamily:'Barlow',
    backgroundColor: blue[900],
    '&:hover': {
      backgroundColor: blue[600],
      color: '#000000',
    },
  }));


const modalstyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '3px solid rgb(90, 134, 237)',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
    overflowX:'auto',
    height:'90%',
    display:'block'
  };

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 9,
  };

  const tablestyle = {
    rows: {
        style:{
            minHeight: '100px',
        },
        highlightOnHoverStyle:{
            color:blueGrey[900],
            backgroundColor:blueGrey[50]
        }
    },
    header: {
        style: {
            maxHeight: '56px',
        },
    },
    headRow: {
        style: {
            borderTopStyle: 'solid',
            borderTopWidth: '1px',
            borderTopColor: defaultThemes.default.divider.default,
            background: blue[900],
            color:'#ffffff',
        },
    },
    headCells: {
        style: {
            '&:not(:last-of-type)': {
                borderRightStyle: 'solid',
                borderRightWidth: '1px',
                borderRightColor: defaultThemes.default.divider.default,
            },
        },
    },
    cells: {
        style: {
            '&:not(:last-of-type)': {
                borderRightStyle: 'solid',
                borderRightWidth: '1px',
                borderRightColor: defaultThemes.default.divider.default,
            },
        },
},
};

const parseToLink = (link)=>{

    let href = "";
    //let href ="https://dati.enea.it";
    
    const fileurl=/\/(.+)\/file\/([0-9]+)/;
    const moreurl=/\/api\/v1\/(.+)\/([0-9]+)/;
    const resource = link.match(fileurl);
    const catalog = link.match(moreurl);
    
    if(resource){
        href = ENEA_GEST_BASE_URL+resource[1]+"/file/"+resource[2]
        //href+="/gest/resource/"+resource[1]+"/file/"+resource[2];
    }
    if(catalog){
        href = ENEA_GEST_API_URL+catalog[1]+"/"+catalog[2];
        //href+="/gest/catalog/"+catalog[1]+"/"+catalog[2];
    }
    return href;
}

const openURL=(url)=>{
    window.open(url,'_blank');
}

const capitalize = (str)=>{
    if(str!==undefined){
        let parts = str.split(" ");
        let cp = parts.map(p=>String(p).charAt(0).toUpperCase() + String(p).slice(1));
        return cp.join(" ");
    }
}

const initials = (str)=>{
    if(str!==undefined){
        let parts = str.split(" ");
        let cp = parts.map(p=>String(p).charAt(0).toUpperCase());
        return cp.join("");
    }
}


const sanitizetel = (str)=>{
    if(str!==undefined){
        if(str.length>0){
            const rgx = /[^0-9\+]/gi;
            return str.replaceAll(rgx,"");
        }
    }
    return "N.D.";
}


const cardDownload = (p)=>{
    return (
        <Fragment>
            <Stack direction="row" spacing={4} sx={{justifyContent:'center',alignItems:'center'}}>
            <Typography variant="body2" component="div">
                del: {p.dt_allegato}
            </Typography>
                <div className='to-screen'>                                    
                    <EneaButton href={parseToLink(p.link)} variant="contained" startIcon={<DownloadIcon/>}>Scarica</EneaButton>
                </div>
            <QRCode className="to-print"
                title={p.nome_file}
                size={64}
                style={{ height: "auto", maxWidth: "30%" }}
                value={parseToLink(p.link)}
                viewBox={`0 0 64 64`}
                />
            </Stack>
        </Fragment>
    );
}

const Myrow = ({name,val})=>{
    if(val===undefined){
        val="-";
    }
    if((val==="")||(val===null)){
        val="-";
    }
    // if(typeof val === "object"){
    //     val = JSON.stringify(val);
    // }
    return(
        <Fragment>
        <Stack direction="row" spacing={2} sx={{p:2}} alignItems="center">
        <p>{name}</p><Typography variant="h5" component="span">{val}</Typography>
        </Stack>
        <Divider sx={{paddingBottom:2}}/>
        </Fragment>
    );
}

const MydivRUP = ({obj})=>{
    return(
        <div>
            <Stack direction="row" spacing={3} alignItems="center">
            <Avatar sx={{bgcolor:blue[700]}} alt={obj.RUP_nome}>{initials(obj.RUP_nome)}</Avatar>
            <Typography variant="h5" component="p"> {capitalize(obj.RUP_nome)}</Typography></Stack>
            <p>email: <Typography variant="h6" component="span">
            <a title="invia mail" href={"mailto:"+obj.RUP_email}>{obj.RUP_email}</a></Typography></p>
            <p>PEC: <Typography variant="h6" component="span">
            <a title="invia mail" href={"mailto:"+obj.RUP_pec}> {obj.RUP_pec||"-"}</a></Typography></p>
            <p>telefono: <Typography variant="h6" component="span">{sanitizetel(obj.RUP_tel)}</Typography></p>
         <p>fax: <Typography variant="h6" component="span">{sanitizetel(obj.RUP_fax)}</Typography></p>
        </div>
    );
}

const MydivCOM = ({obj})=>{
    return(
        <div>
            <Stack direction="row" spacing={2} sx={{p:2}} alignItems="center">
            <p>presidente commissione</p><Typography variant="h5" component="span"> {capitalize(obj.presidente_commissione)}</Typography>
            </Stack><Stack direction="row" spacing={2} sx={{p:2}} alignItems="center">
            <p>primo membro commissione</p><Typography variant="h5" component="span"> {capitalize(obj.primo_membro_commissione)}</Typography>
            </Stack><Stack direction="row" spacing={2} sx={{p:2}} alignItems="center">
            <p>secondo membro commissione</p><Typography variant="h5" component="p"> {capitalize(obj.secondo_membro_commissione)}</Typography>
            </Stack><Stack direction="row" spacing={2} sx={{p:2}} alignItems="center">
            <p>primo membro supplente commissione</p><Typography variant="h5" component="p"> {capitalize(obj.primo_membro_suppl_comm)}</Typography>
            </Stack><Stack direction="row" spacing={2} sx={{p:2}} alignItems="center">
            <p>secondo membro supplente commissione</p><Typography variant="h5" component="p"> {capitalize(obj.secondo_membro_suppl_comm)}</Typography>
            </Stack>
        </div>
    );
}

const Mysection =({text})=>{
    return (
        <Fragment>
        <Divider/>
        <Grid2 padding={5}  justifySelf="center"> 
            <Typography variant="h3" sx={{fontSize:32}} component="span">{text}</Typography>
        </Grid2>
        </Fragment>
    );
}

const measuretype = (t)=>{
    if(1) return "giorni";
    if(2) return "mesi";
    if(3) return "anni";
}


export {Mysection,MydivCOM,MydivRUP,Myrow,measuretype,cardDownload, sanitizetel,initials,capitalize,openURL,EneaButton,tablestyle,modalstyle,dateSort,concurrecySort,parseToLink};